'use client'

import React from 'react'

import { Flex } from '@chakra-ui/react'

import { ColorScheme, Tag, TagProps } from '../Tag/Tag'
import { tagGroupNoWrapStyles, tagGroupStyles } from './TagGroup.styles'

// Always mounted so its width can be measured; hidden until truncation is needed
const EllipsisTag = ({
  visible,
  colorScheme,
}: {
  visible: boolean
  colorScheme?: ColorScheme
}) => {
  return (
    <span
      data-tag-ellipsis=''
      style={
        visible
          ? { flexShrink: 0 }
          : {
              position: 'absolute',
              visibility: 'hidden',
              pointerEvents: 'none',
            }
      }
    >
      <Tag colorScheme={colorScheme} value='...' />
    </span>
  )
}

export type TagGroupNoWrapProps = {
  refCallback: (node: HTMLDivElement | null) => void
  className?: string
  childArray: React.ReactElement<TagProps>[]
  visibleCount: number | undefined
  effectiveMaxWidth: string | number
  colorScheme?: ColorScheme
}

export const TagGroupNoWrap = ({
  refCallback,
  className,
  childArray,
  visibleCount,
  effectiveMaxWidth,
  colorScheme,
}: TagGroupNoWrapProps) => {
  const isTruncated = visibleCount !== undefined

  return (
    <Flex
      className={className}
      ref={refCallback}
      {...tagGroupStyles}
      {...tagGroupNoWrapStyles}
    >
      {childArray.map((child, i) => {
        const isHidden = isTruncated && i >= visibleCount!
        return (
          <span
            data-tag-item=''
            key={child.key ?? i}
            style={{ flexShrink: 0, display: isHidden ? 'none' : undefined }}
          >
            <Tag
              {...child.props}
              colorScheme={colorScheme}
              maxWidth={effectiveMaxWidth}
            />
          </span>
        )
      })}
      <EllipsisTag colorScheme={colorScheme} visible={isTruncated} />
    </Flex>
  )
}
